// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2wEJ5","alert":"SettungsInbox_alert__1q08X"};